// extracted by mini-css-extract-plugin
module.exports = {"item":"Navigation_item__2T5qw"};